//初始化数据

const state = {
    roleCode: null,
    userinfo:null,
    userId:'',
    token: ''
}

//getter
const getters = {
    roleCode: function (state) {
        if (!state.roleCode) {
            state.roleCode = JSON.parse(sessionStorage.getItem('roleCode'))
        }
        return state.roleCode
    },
    userinfo: function (state) {
        if (!state.userinfo) {
            state.userinfo = JSON.parse(localStorage.getItem('userinfo'))
        }
        return state.userinfo
    },
    userId: function (state) {
        if (!state.userId) {
            let userinfo = JSON.parse(localStorage.getItem('userinfo'))
            state.userId = userinfo.userModel.id
        }
        return state.userId
    },
    token: function (state) {
        if (!state.token) {
            state.token = JSON.parse(localStorage.getItem('token'));
        }
        return state.token
    }
}

//action
const actions = {
    setRoleCode({ commit }, u) {
        commit('SET_ROLECODE', u)
    },
    setLoginInfo({ commit }, u) {
        commit('SET_LOGININFO', u)
    },
    setToken({ commit }, t) {
        commit('SET_TOKEN', t);
    }
}

//mutation
const mutations = {
    SET_ROLECODE(state, i) {
        state.roleCode = i;
        sessionStorage.setItem('roleCode', JSON.stringify(i))
    },
    SET_LOGININFO(state, i) {
        state.loginInfo = i;
        localStorage.setItem('loginInfo', JSON.stringify(i))
    },
    SET_TOKEN(state, t) {
        state.token = t;
        localStorage.setItem('token', JSON.stringify(t));
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
};